export default __webpack_public_path__ + "static/graph-api-4dcb53dbdaeebee20caefafc172fc4af.svg";